import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import SideArrow from './sideArrow.svg.js';
import TextLabel from '../textLabel';
import InfoIcon from '../infoIcon';
import { dataHooks } from './constants';

var AccordionSection = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionSection, _React$Component);

  var _super = _createSuper(AccordionSection);

  function AccordionSection() {
    var _this;

    _classCallCheck(this, AccordionSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "_toggle", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          isOpen = _this$props.isOpen,
          onToggle = _this$props.onToggle;

      if (disabled) {
        return;
      } // Controlled


      if (typeof isOpen === 'boolean') {
        if (_.isFunction(onToggle)) {
          onToggle(!isOpen);
        } // Uncontrolled

      } else {
        _this.setState({
          isOpen: !_this.state.isOpen
        }, function () {
          if (_.isFunction(onToggle)) {
            onToggle(_this.state.isOpen);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_isOpen", function () {
      var isOpen = _this.props.isOpen;
      return typeof isOpen === 'boolean' ? isOpen : _this.state.isOpen;
    });

    _defineProperty(_assertThisInitialized(_this), "_getRootClassNames", function () {
      var _this$props2 = _this.props,
          getClassName = _this$props2.getClassName,
          disabled = _this$props2.disabled,
          removePadding = _this$props2.removePadding,
          removeTopDivider = _this$props2.removeTopDivider,
          removeBottomDivider = _this$props2.removeBottomDivider;
      return getClassName('control-accordion-section') + (disabled ? ' disabled' : '') + (_this._isOpen() ? ' open' : '') + (removePadding ? ' noPadding' : '') + (removeTopDivider ? ' noTopDivider' : '') + (removeBottomDivider ? ' noBottomDivider' : '');
    });

    return _this;
  }

  _createClass(AccordionSection, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          children = _this$props3.children,
          label = _this$props3.label,
          shouldTranslate = _this$props3.shouldTranslate,
          infoContent = _this$props3.infoContent,
          automationId = _this$props3.automationId,
          dataHook = _this$props3.dataHook,
          infoContentLink = _this$props3.infoContentLink;
      return /*#__PURE__*/React.createElement("div", {
        className: this._getRootClassNames(),
        "data-aid": automationId,
        "data-hook": dataHook,
        disabled: disabled
      }, /*#__PURE__*/React.createElement("div", {
        className: "accordion-section-header",
        "data-hook": dataHooks.header,
        onClick: this._toggle,
        "aria-checked": this._isOpen()
      }, /*#__PURE__*/React.createElement("div", {
        className: "accordion-section-side-icon"
      }, /*#__PURE__*/React.createElement(SideArrow, null)), /*#__PURE__*/React.createElement("div", {
        className: "accordion-section-label"
      }, /*#__PURE__*/React.createElement(TextLabel, {
        dataHook: dataHooks.label,
        value: label,
        shouldTranslate: shouldTranslate
      })), !disabled && infoContent && /*#__PURE__*/React.createElement("div", {
        key: "accordion-section-tooltip",
        className: "accordion-section-tooltip"
      }, /*#__PURE__*/React.createElement(InfoIcon, {
        dataHook: dataHooks.tooltip,
        text: infoContent,
        shouldTranslate: shouldTranslate,
        linkText: infoContentLink && infoContentLink.text,
        onLinkClick: infoContentLink && infoContentLink.onClick
      }))), this._isOpen() && /*#__PURE__*/React.createElement("div", {
        key: "accordion-section-container",
        className: "accordion-section-container",
        "data-hook": dataHooks.children
      }, children));
    }
  }]);

  return AccordionSection;
}(React.Component);

AccordionSection.displayName = 'AccordionSection';
AccordionSection.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,

  /** Textual description for the block */
  label: PropTypes.string,

  /** Add information as a tooltip content */
  infoContent: PropTypes.string,

  /** Link to be displayed ath the end of the info content inside the tooltip */
  infoContentLink: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }),

  /** Disable toggling and click events to happen */
  disabled: PropTypes.bool,

  /** Will be called when the the accordion element is open with (isOpen: boolean) */
  onToggle: PropTypes.func,

  /** Sets the open state of the accordion block and sets the component in a controlled state */
  isOpen: PropTypes.bool,

  /** The content to be rendered when the accordion section is open */
  children: PropTypes.any,

  /** Remove the default side padding from the accordion content, and the bottom padding from the accordion header*/
  removePadding: PropTypes.bool,

  /** Remove the top divider of */
  removeTopDivider: PropTypes.bool,

  /** Remove the bottom divider */
  removeBottomDivider: PropTypes.bool
};
AccordionSection.defaultProps = {
  disabled: false,
  removePadding: false,
  removeTopDivider: false,
  removeBottomDivider: false,
  label: ''
};
export default compose(AccordionSection);